import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-3" }
const _hoisted_2 = {
  key: 0,
  class: "text-muted py-4 text-center"
}

import { computed } from 'vue'
import type { ApexOptions } from 'apexcharts'
import type { TimeSeries, KpiStat } from '@/services/adminStatsApi'


export default /*@__PURE__*/_defineComponent({
  __name: 'StatsRatingChart',
  props: {
    distribution: {},
    avgRating: {}
  },
  setup(__props: any) {

const props = __props

const isEmpty = computed(() =>
  !props.distribution.series[0]?.data.some(v => v > 0)
)

const chartOptions = computed<ApexOptions>(() => ({
  labels: props.distribution.labels,
  colors: ['#ef4444', '#f97316', '#f59e0b', '#84cc16', '#10b981'],
  legend: { position: 'bottom' },
  plotOptions: {
    pie: {
      donut: {
        labels: {
          show: true,
          total: {
            show: true,
            label: 'Ort. Puan',
            formatter: () =>
              props.avgRating.current !== null
                ? `${props.avgRating.current} ★`
                : '—',
          },
        },
      },
    },
  },
  dataLabels: { enabled: false },
  tooltip: { y: { formatter: (v: number) => `${v} değerlendirme` } },
}))

return (_ctx: any,_cache: any) => {
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "trezo-card bg-white border-0 shadow-none border-radius mb-0" }, {
    default: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "v-card-header" }, [
        _createElementVNode("h5", { class: "mb-0" }, "Yanıt Derecelendirme Dağılımı")
      ], -1)),
      _createElementVNode("div", _hoisted_1, [
        (isEmpty.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Henüz derecelendirme yok "))
          : (_openBlock(), _createBlock(_component_apexchart, {
              key: 1,
              type: "donut",
              height: "280",
              options: chartOptions.value,
              series: __props.distribution.series[0]?.data ?? []
            }, null, 8, ["options", "series"]))
      ])
    ]),
    _: 1
  }))
}
}

})